import "client-only";
import { fetcher } from "src/utils/fetcher";
import useSWR from "swr";
function useProviderDetail(id) {
  return useSWR(
    !id
      ? null
      : {
          path: `/api/v1/providers/${id}`,
          method: "GET",
        },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useProviderDetail;
